import React from "react";
import { DownloadIcon, DuplicateIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { QRCodeCanvas } from "qrcode.react";
import { Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import { copyUrl, downloadQRCode } from "./helpers";

type CodeQRType = {
    qrData: any;
    qrCodeRefs: any;
    isModified: boolean;
    setIsOpened: Function;
    ref: any;
    Id: any;
    setMessage: Function;
    setIsCopy: Function;
};
export function CodeQR({
    qrData,
    qrCodeRefs,
    isModified,
    setIsOpened,
    ref,
    Id,
    setMessage,
    setIsCopy,
}: CodeQRType) {
    const { t } = useTranslation();

    const copyUrlQR = () => {
        if (isModified) {
            setMessage(
                t(
                    "Warning: Changes have not been saved. Do you still want to continue and retrieve the existing QR code?"
                )
            );
            setIsOpened(true);
            setIsCopy(true);
        } else {
            copyUrl(qrData, t);
        }
    };
    const downloadQRCodeImage = () => {
        if (isModified) {
            setMessage(
                t(
                    "Warning: Changes have not been saved. Do you still want to continue and download the existing QR code?"
                )
            );
            setIsOpened(true);
            setIsCopy(false);
        } else {
            downloadQRCode(Id, qrCodeRefs, t);
        }
    };

    return (
        <div
            className="d-flex flex-wrap justify-content-center align-items-center"
            style={{
                border: "unset",
                borderRadius: "6px",
                height: "100%",
                width: "auto",
                padding: "1rem",
            }}
        >
            <Card className={classnames("uploader__clz lgo_inp_FRlogo")}>
                {qrData !== "" ? (
                    <React.Fragment>
                        <div
                            className=" d-flex justify-content-center align-items-center"
                            style={{
                                height: "77%",
                                width: "100%",
                            }}
                            ref={ref}
                        >
                            <QRCodeCanvas value={qrData} />
                        </div>
                        <div className=" d-flex justify-content-around mt-2">
                            <label
                                style={{
                                    cursor: "pointer",
                                    marginRight: "50%",
                                }}
                                onClick={downloadQRCodeImage}
                            >
                                <DownloadIcon height={20} width={20} />
                            </label>
                            <span
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={copyUrlQR}
                            >
                                <DuplicateIcon height={20} width={20} />
                            </span>
                        </div>
                    </React.Fragment>
                ) : null}
            </Card>
        </div>
    );
}
